export const articleTypes = {
    aluminium: 'Aluminium',
    calendar: 'Calendar',
    canvas: 'Canvas',
    card: 'Card',
    forex: 'Forex',
    mug: 'Mug',
    lovemug: 'LoveMug',
    magicmug: 'MagicMug',
    jigsaw: 'Jigsaw',
    cushion: 'Cushion',
    magnet: 'Magnet',
    photobook: 'Photobook',
    plexiglas: 'Plexiglas',
    poster: 'Poster',
    prints: 'Prints',
    studentPlakat: 'StudentPlakat',
    voucher: 'Voucher',
    paddedPhotoBook: 'PaddedPhotoBook',
    cutoutPhotoBook: 'CutoutPhotoBook',
    momentsPhotoBook: 'MomentsPhotoBook',
};

export const articleTypeGroups = {
    Walldecor: [
        articleTypes.aluminium,
        articleTypes.canvas,
        articleTypes.forex,
        articleTypes.plexiglas,
        articleTypes.poster,
    ],
};
